import styled, { css } from 'styled-components';
import dynamic from 'next/dynamic';

import { FeatureFlags } from 'featureFlags/constants';
import { t } from 'localization/utils/t';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useWindowState } from 'productTemplate/hooks/useWindowState';

const PricingActivityWindowDeprecated = dynamic(
  () => import('productTemplate/components/windows/PricingActivityWindowDeprecated'),
  {
    ssr: false,
  },
);

const PricingActivityWindow = dynamic(
  () => import('productTemplate/components/windows/PricingActivityWindow'),
  {
    ssr: false,
  },
);

const ClientOnlyPortal = dynamic(
  () => import('shared/components/ClientOnlyPortal').then((mod) => mod.ClientOnlyPortal),
  {
    ssr: false,
  },
);

const TP = 'productTemplate.components.footer.ProductTemplateMobileFooterLinks';

export const MobileActivityButton = () => {
  const isNewPricingActivityEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ACTIVITY_MODAL);
  const {
    windowState: pricingActivityWindowState,
    handleLinkClick: handlePricingActivityClick,
    handleLinkClose: handlePricingActivityClose,
  } = useWindowState();

  return (
    <MobileActivityButton.Wrapper $isOpen={pricingActivityWindowState.isOpen}>
      <button
        data-qa="product_template_activity_button"
        onClick={handlePricingActivityClick}
        type="button"
      >
        {t(`${TP}.activity`, 'Activity')}
      </button>

      {pricingActivityWindowState.isOpen && (
        <ClientOnlyPortal selector="#main-page-layout">
          {isNewPricingActivityEnabled ? (
            <PricingActivityWindow
              isPermanent={pricingActivityWindowState.isPermanent}
              onClose={handlePricingActivityClose}
            />
          ) : (
            <PricingActivityWindowDeprecated
              isPermanent={pricingActivityWindowState.isPermanent}
              onClose={handlePricingActivityClose}
            />
          )}
        </ClientOnlyPortal>
      )}
    </MobileActivityButton.Wrapper>
  );
};

MobileActivityButton.Wrapper = styled.div<{ $isOpen?: boolean }>`
  display: flex;

  button {
    padding: 10px 8px;
    margin-top: -10px;

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        text-decoration: underline;
      `}
  }
`;
